export const UPDATE_TRANSLATION = 'UPDATE_TRANSLATION'

const initialState = {
  updated_screen: null,
}

export default function (
  state = {
    ...initialState,
  },
  action = {}
) {
  switch (action.type) {
    case UPDATE_TRANSLATION:
      return {
        ...state,
      }
    default:
      return state
  }
}
